/**
 * پاسخ‌های ساختگی هم‌شکل با آنچه فرانت از گزارش‌ها انتظار دارد
 * (ساختار مطابق extractRows / extractPagination و فیلدهای جدول در هر صفحه).
 */

const delay = (ms = 60) => new Promise((r) => setTimeout(r, ms));

/**
 * ساختار هم‌راستا با extractRows / extractPagination:
 * response.data = { data: ردیف‌ها, current_page, per_page, total }
 */
const wrapPage = (rows, page = 1, perPage = 15, total = null) => ({
  data: rows,
  current_page: page,
  per_page: perPage,
  total: total != null ? total : rows.length,
});

/** گزارش مالی — ردیف‌ها: paid_on, invoice_*, amount برای نمودار */
export async function getFinanceReport(filters = {}) {
  await delay();
  const rows = [
    {
      id: 1,
      paid_on: '1404/10/02',
      invoice_number: 'INV-24001',
      client_name: 'شرکت نوآوران داده',
      invoice_value: '12,500,000',
      amount_paid: '12,500,000',
      bank_account: 'بانک ملت — 6037',
      amount: 12500000,
    },
    {
      id: 2,
      paid_on: '1404/10/08',
      invoice_number: 'INV-24002',
      client_name: 'آریا تجارت',
      invoice_value: '8,200,000',
      amount_paid: '8,200,000',
      bank_account: 'بانک ملی — 6037',
      amount: 8200000,
    },
    {
      id: 3,
      paid_on: '1404/10/15',
      invoice_number: 'INV-24003',
      client_name: 'فناوران آسمان',
      invoice_value: '22,000,000',
      amount_paid: '15,000,000',
      bank_account: 'بانک سپه',
      amount: 15000000,
    },
    {
      id: 4,
      paid_on: '1404/10/22',
      invoice_number: 'INV-24004',
      client_name: 'شرکت نوآوران داده',
      invoice_value: '5,400,000',
      amount_paid: '5,400,000',
      bank_account: 'بانک ملت — 6037',
      amount: 5400000,
    },
    {
      id: 5,
      paid_on: '1404/11/01',
      invoice_number: 'INV-24005',
      client_name: 'گسترش صنعت',
      invoice_value: '31,000,000',
      amount_paid: '31,000,000',
      bank_account: 'پاسارگاد',
      amount: 31000000,
    },
    {
      id: 6,
      paid_on: '1404/11/12',
      invoice_number: 'INV-24006',
      client_name: 'آریا تجارت',
      invoice_value: '9,800,000',
      amount_paid: '9,800,000',
      bank_account: 'بانک ملی — 6037',
      amount: 9800000,
    },
    {
      id: 7,
      paid_on: '1404/11/20',
      invoice_number: 'INV-24007',
      client_name: 'فناوران آسمان',
      invoice_value: '18,500,000',
      amount_paid: '10,000,000',
      bank_account: 'بانک سپه',
      amount: 10000000,
    },
  ];
  return {
    data: wrapPage(rows, filters.page ?? 1, filters.per_page ?? 15, 24),
    filters: {
      projects: [
        { id: 101, project_name: 'پروژهٔ وب CRM', name: 'پروژهٔ وب CRM' },
        { id: 102, project_name: 'اپ موبایل', name: 'اپ موبایل' },
      ],
      clients: [
        { id: 1, name: 'شرکت نوآوران داده' },
        { id: 2, name: 'آریا تجارت' },
        { id: 3, name: 'فناوران آسمان' },
        { id: 4, name: 'گسترش صنعت' },
      ],
    },
  };
}

/** درآمد / هزینه — income, expense یا total_* به صورت عدد */
export async function getIncomeExpenseReport() {
  await delay();
  const rows = [
    { id: 1, date: '1405/01/05', income: 18500000, expense: 9200000 },
    { id: 2, date: '1405/01/12', income: 21200000, expense: 11300000 },
    { id: 3, date: '1405/01/19', income: 17600000, expense: 10800000 },
    { id: 4, date: '1405/01/26', income: 24100000, expense: 14200000 },
    { id: 5, date: '1405/02/03', income: 19800000, expense: 12100000 },
    { id: 6, date: '1405/02/10', income: 26300000, expense: 15900000 },
    { id: 7, date: '1405/02/17', income: 18900000, expense: 9900000 },
  ];
  return { data: wrapPage(rows, 1, 50, rows.length) };
}

export async function getLeaveReport(filters = {}) {
  await delay();
  const rows = [
    {
      id: 1,
      employee_name: 'علی احمدی',
      designation_name: 'توسعه‌دهنده ارشد',
      count_approved_leaves: 4,
      count_pending_leaves: 1,
      mobile_with_phonecode: '+98 912 100 2233',
      image_url: undefined,
    },
    {
      id: 2,
      employee_name: 'سارا کریمی',
      designation_name: 'تحلیلگر کسب‌وکار',
      count_approved_leaves: 2,
      count_pending_leaves: 0,
      mobile_with_phonecode: '+98 913 200 4455',
    },
    {
      id: 3,
      employee_name: 'رضا محمدی',
      designation_name: 'پشتیبان فنی',
      count_approved_leaves: 5,
      count_pending_leaves: 2,
      mobile_with_phonecode: '+98 914 300 6677',
    },
    {
      id: 4,
      employee_name: 'مریم نوری',
      designation_name: 'مدیر محصول',
      count_approved_leaves: 3,
      count_pending_leaves: 0,
      mobile_with_phonecode: '+98 915 400 8899',
    },
  ];
  return {
    data: wrapPage(rows, filters.page ?? 1, filters.per_page ?? 15, rows.length),
  };
}

export async function getLeaveQuotaReport(filters = {}) {
  await delay();
  const rows = [
    { id: 1, employee_id: 101, employee_name: 'سارا کریمی', allocated: 26, used: 9, remaining: 17 },
    { id: 2, employee_id: 102, employee_name: 'رضا محمدی', allocated: 26, used: 14, remaining: 12 },
    { id: 3, employee_id: 103, employee_name: 'علی احمدی', allocated: 26, used: 6, remaining: 20 },
    { id: 4, employee_id: 104, employee_name: 'مریم نوری', allocated: 26, used: 11, remaining: 15 },
  ];
  return {
    data: wrapPage(rows, filters.page ?? 1, filters.per_page ?? 10, rows.length),
    filters: {
      employees: [
        { id: 101, name: 'سارا کریمی' },
        { id: 102, name: 'رضا محمدی' },
        { id: 103, name: 'علی احمدی' },
        { id: 104, name: 'مریم نوری' },
      ],
    },
  };
}

export async function getEmployeeLeaveQuotaDetail(employeeId, year, month) {
  await delay();
  return {
    data: {
      کارمند: `شناسه ${employeeId}`,
      سال: String(year),
      ماه: String(month),
      سهمیه_استحقاقی: 26,
      استفاده_شده: 9,
      باقیمانده: 17,
      انتقال_از_سال_قبل: 2,
      مرخصی_استعلاجی: 1,
    },
  };
}

export async function getAttendanceReport(filters = {}) {
  await delay();
  const employees = [
    { id: 201, name: 'علی احمدی' },
    { id: 202, name: 'سارا کریمی' },
    { id: 203, name: 'رضا محمدی' },
  ];
  const rows = [
    {
      id: 1,
      employee_name: 'علی احمدی',
      present_days: 21,
      extra_days: 1,
      absent_days: 0,
      hours_clocked: '176:15',
      late_day_count: 1,
      half_day_count: 0,
    },
    {
      id: 2,
      employee_name: 'سارا کریمی',
      present_days: 20,
      extra_days: 0,
      absent_days: 1,
      hours_clocked: '168:00',
      late_day_count: 3,
      half_day_count: 1,
    },
    {
      id: 3,
      employee_name: 'رضا محمدی',
      present_days: 22,
      extra_days: 0,
      absent_days: 0,
      hours_clocked: '184:30',
      late_day_count: 0,
      half_day_count: 0,
    },
  ];
  return {
    data: wrapPage(rows, 1, 50, rows.length),
    meta: { total_working_days: 22, holidays_count: 2 },
    filters: { employees },
    employees,
  };
}

export async function getExpenseReport(filters = {}) {
  await delay();
  const rows = [
    {
      id: 1,
      date: '1404/10/05',
      title: 'خرید لایسنس نرم‌افزار',
      category_name: 'فناوری اطلاعات',
      amount: '4,200,000',
      employee_name: 'علی احمدی',
      project_name: 'وب CRM',
    },
    {
      id: 2,
      date: '1404/10/12',
      title: 'ایاب و ذهاب',
      category_name: 'رفاه',
      amount: '1,850,000',
      employee_name: 'سارا کریمی',
      project_name: '—',
    },
    {
      id: 3,
      date: '1404/10/18',
      title: 'پذیرایی جلسه',
      category_name: 'اداری',
      amount: '620,000',
      employee_name: 'مریم نوری',
      project_name: 'اپ موبایل',
    },
    {
      id: 4,
      date: '1404/11/02',
      title: 'تجهیزات اداری',
      category_name: 'اداری',
      amount: '9,100,000',
      employee_name: 'رضا محمدی',
      project_name: 'وب CRM',
    },
    {
      id: 5,
      date: '1404/11/15',
      title: 'آموزش خارجی',
      category_name: 'آموزش',
      amount: '12,000,000',
      employee_name: 'علی احمدی',
      project_name: '—',
    },
  ];
  return {
    data: wrapPage(rows, filters.page ?? 1, filters.per_page ?? 15, 18),
    filters: {
      categories: [
        { id: 1, name: 'فناوری اطلاعات' },
        { id: 2, name: 'رفاه' },
        { id: 3, name: 'اداری' },
        { id: 4, name: 'آموزش' },
      ],
      projects: [
        { id: 101, project_name: 'وب CRM', name: 'وب CRM' },
        { id: 102, project_name: 'اپ موبایل', name: 'اپ موبایل' },
      ],
      employees: [
        { id: 1, name: 'علی احمدی' },
        { id: 2, name: 'سارا کریمی' },
        { id: 3, name: 'رضا محمدی' },
        { id: 4, name: 'مریم نوری' },
      ],
    },
  };
}

export async function getExpenseCategoryReport(filters = {}) {
  await delay();
  const catRows = [
    { category_name: 'فناوری اطلاعات', amount: 14200000 },
    { category_name: 'اداری', amount: 9800000 },
    { category_name: 'رفاه', amount: 5200000 },
    { category_name: 'آموزش', amount: 12000000 },
    { category_name: 'سایر', amount: 3100000 },
  ];
  return {
    data: wrapPage(catRows, 1, 50, catRows.length),
    filters: {
      categories: [
        { id: 1, name: 'فناوری اطلاعات' },
        { id: 2, name: 'اداری' },
        { id: 3, name: 'رفاه' },
        { id: 4, name: 'آموزش' },
      ],
    },
  };
}

export async function getLeadReportChart(filters = {}) {
  await delay();
  const year = filters.year ?? '1405';
  const chartRows = [
    { label: 'سرنخ', stage: 'سرنخ', count: 145, value: 145 },
    { label: 'تماس اولیه', stage: 'تماس اولیه', count: 98, value: 98 },
    { label: 'جلسه', stage: 'جلسه', count: 62, value: 62 },
    { label: 'پیشنهاد', stage: 'پیشنهاد', count: 34, value: 34 },
    { label: 'مذاکره', stage: 'مذاکره', count: 21, value: 21 },
    { label: 'بستن', stage: 'بستن', count: 12, value: 12 },
  ];
  return {
    data: wrapPage(chartRows, 1, 50, chartRows.length),
    filters: {
      pipelines: [
        { id: 1, name: 'فروش محصول' },
        { id: 2, name: 'فروش خدمات' },
      ],
      categories: [
        { id: 1, name: 'B2B' },
        { id: 2, name: 'B2C' },
      ],
      year,
    },
  };
}

export async function getLeadReportList(filters = {}) {
  await delay();
  const rows = [
    {
      id: 1,
      name: 'قرارداد پشتیبانی سالانه',
      client_name: 'نوآوران داده',
      pipeline_stage: 'پیشنهاد',
      value: '85,000,000 تومان',
      agent_name: 'نیما رضایی',
    },
    {
      id: 2,
      name: 'لایسنس سازمانی',
      client_name: 'آریا تجارت',
      pipeline_stage: 'مذاکره',
      value: '120,000,000 تومان',
      agent_name: 'الهام کاظمی',
    },
    {
      id: 3,
      name: 'پیاده‌سازی ماژول مالی',
      client_name: 'گسترش صنعت',
      pipeline_stage: 'جلسه',
      value: '45,000,000 تومان',
      agent_name: 'نیما رضایی',
    },
    {
      id: 4,
      name: 'فاز دوم CRM',
      client_name: 'فناوران آسمان',
      pipeline_stage: 'بستن',
      value: '210,000,000 تومان',
      agent_name: 'پویا سالاری',
    },
  ];
  return {
    data: wrapPage(rows, filters.page ?? 1, filters.per_page ?? 15, rows.length),
    filters: {
      agents: [
        { id: 1, name: 'نیما رضایی' },
        { id: 2, name: 'الهام کاظمی' },
        { id: 3, name: 'پویا سالاری' },
      ],
      pipelines: [
        { id: 1, name: 'فروش محصول' },
        { id: 2, name: 'فروش خدمات' },
      ],
      categories: [
        { id: 1, name: 'B2B' },
        { id: 2, name: 'B2C' },
      ],
    },
  };
}

export async function getSalesReport(filters = {}) {
  await delay();
  const rows = [
    {
      id: 1,
      paid_on: '1404/10/03',
      invoice_number: 'SL-9901',
      client_name: 'نوآوران داده',
      invoice_value: '28,000,000 تومان',
      taxable_value: '28,000,000 تومان',
      discount: '—',
      amount_paid: '28,000,000 تومان',
      bank_account: 'ملت',
    },
    {
      id: 2,
      paid_on: '1404/10/14',
      invoice_number: 'SL-9902',
      client_name: 'آریا تجارت',
      invoice_value: '15,500,000 تومان',
      taxable_value: '14,200,000 تومان',
      discount: '8%',
      amount_paid: '15,500,000 تومان',
      bank_account: 'ملی',
    },
    {
      id: 3,
      paid_on: '1404/11/05',
      invoice_number: 'SL-9903',
      client_name: 'فناوران آسمان',
      invoice_value: '62,000,000 تومان',
      taxable_value: '62,000,000 تومان',
      discount: '—',
      amount_paid: '40,000,000 تومان',
      bank_account: 'سپه',
    },
  ];
  return {
    data: wrapPage(rows, filters.page ?? 1, filters.per_page ?? 15, 12),
    filters: {
      clients: [
        { id: 1, name: 'نوآوران داده' },
        { id: 2, name: 'آریا تجارت' },
        { id: 3, name: 'فناوران آسمان' },
      ],
    },
  };
}
